import { apiClient } from "./client";
import type { PasskeySummary } from "@abejon/shared";
import type {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";

// ─── Registration ────────────────────────────────────────

export async function getRegistrationOptions() {
  return apiClient<{
    challengeId: string;
    options: PublicKeyCredentialCreationOptionsJSON;
  }>("/auth/passkey/register/options", { method: "POST" });
}

export async function verifyRegistration(
  challengeId: string,
  credential: unknown
) {
  return apiClient<{ verified: boolean }>("/auth/passkey/register/verify", {
    method: "POST",
    body: { challengeId, credential },
  });
}

// ─── Authentication ──────────────────────────────────────

export async function getLoginOptions() {
  return apiClient<{
    challengeId: string;
    options: PublicKeyCredentialRequestOptionsJSON;
  }>("/auth/passkey/login/options", { method: "POST" });
}

export async function verifyLogin(challengeId: string, credential: unknown) {
  return apiClient<{ verified: boolean }>("/auth/passkey/login/verify", {
    method: "POST",
    body: { challengeId, credential },
  });
}

// ─── Management ──────────────────────────────────────────

export async function getMyPasskeys() {
  return apiClient<{ passkeys: PasskeySummary[] }>("/users/me/passkeys");
}

export async function deletePasskey(id: string) {
  return apiClient<{ message: string }>(`/users/me/passkeys/${id}`, {
    method: "DELETE",
  });
}
